import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noJqlReturned: {
		// TODO - update i18n ID when cleaning up the FF for JNLIS-410
		id: 'natural-language-to-jql.services.use-natural-language-to-jql.no-jql-returned',
		defaultMessage: 'We couldn’t turn your input into a JQL query. Try adding more details.',
		description:
			'Warning message displayed to the user when no JQL or relevant errors were returned trying to translate an input prompt to JQL.',
	},
	invalidJqlErrorNonFinal: {
		id: 'natural-language-to-jql.use-natural-language-to-jql.invalid-jql-error-non-final',
		defaultMessage:
			'Atlassian Intelligence couldn’t process your query. Try including specific fields from your issues or projects.',
		description:
			'Generic error message displayed to the user when an unexpected error has occurred trying to translate an input prompt to JQL.',
	},
	errorRateLimit: {
		id: 'natural-language-to-jql.use-natural-language-to-jql.error-rate-limit',
		defaultMessage:
			'Excessive use has been detected with Atlassian Intelligence. Try again later. Read more <support_link>in our support documentation</support_link>.',
		description:
			'Error message displayed to the user when a 429 Too Many Requests error has occurred.',
	},
	helpUsImproveNonFinal: {
		id: 'natural-language-to-jql.use-natural-language-to-jql.help-us-improve-non-final',
		defaultMessage: 'Help us improve your search',
		description: 'Text shown for a button to submit input feedback to Atlassian.',
	},
	unsupportedLanguageErrorNonFinal: {
		id: 'natural-language-to-jql.use-natural-language-to-jql.unsupported-language-error-non-final',
		defaultMessage:
			'Atlassian Intelligence currently can’t translate non-English words. Try editing your query.',
		description: 'Error message displayed to the user when an unsupported language is used',
	},
	serverError: {
		id: 'natural-language-to-jql.use-natural-language-to-jql.server-error',
		defaultMessage:
			"Atlassian Intelligence can't provide a response right now. Read more <support_link>in our support documentation</support_link>.",
		description: 'Standardised server or infrastructure related error',
	},
	invalidJqlErrorNonFinalIssueTerminologyRefreshM4: {
		id: 'natural-language-to-jql.use-natural-language-to-jql.invalid-jql-error-non-final-issue-terminology-refresh-m4',
		defaultMessage:
			'Atlassian Intelligence couldn’t process your query. Try including specific fields from your work items or projects.',
		description:
			'Generic error message displayed to the user when an unexpected error has occurred trying to translate an input prompt to JQL.',
	},
	invalidJqlErrorNonFinalIssueTerminologyRefreshM4Galaxia: {
		id: 'natural-language-to-jql.use-natural-language-to-jql.invalid-jql-error-non-final-galaxia',
		defaultMessage:
			'Atlassian Intelligence couldn’t process your query. Try including specific fields from your work items or spaces.',
		description:
			'Generic error message displayed to the user when an unexpected error has occurred trying to translate an input prompt to JQL.',
	},
});
